document.addEventListener('DOMContentLoaded', () => {
    if (window.innerWidth < 990) return;

    const menuItems = document.querySelectorAll(
        '.header__submenu details, .header__inline-menu details'
    );

    menuItems.forEach((item) => {
        item.addEventListener('mouseenter', () => {
        item.setAttribute('open', '');
        });

        item.addEventListener('mouseleave', () => {
        item.removeAttribute('open');
        });
    });
});